export interface MmiAutoSuggestData {
  alternateName: string;
  distance: number;
  eLoc: string;
  keywords: string[];
  orderIndex: number;
  placeAddress: string;
  placeName: string;
  suggester: string;
  type: string;
}
